var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{staticClass:"custom-overlay",attrs:{"show":_vm.loading}},[_c('div',{staticClass:"loading-wrapper"},[_c('van-loading',{attrs:{"type":"spinner","vertical":"","size":"36"}},[_vm._v("加载中...")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }